import isString from 'lodash/isString'

import { BadgeColors } from '../../components/Badge'
import { FullTags, MappedTag } from './GuestTagBadge.types'

export const AVANTSTAY_EMPLOYEE_TAG = 'AvantStay Employee'
export const DISPUTE_LOST_TAG = 'Dispute Lost'
export const DISPUTE_WON_TAG = 'Dispute Won'

export const getBadgeColor = (tagName: string) => {
  if (tagName === DISPUTE_LOST_TAG || tagName.includes('Policy Violation')) {
    return BadgeColors.failure
  }
  if (tagName === DISPUTE_WON_TAG) {
    return BadgeColors.success
  }
  if (tagName === AVANTSTAY_EMPLOYEE_TAG) {
    return BadgeColors.accent
  }
  return BadgeColors.warning
}

export const sortTagsByHierarchy = (tags: MappedTag[]): MappedTag[] => {
  return [...tags].sort((a, b) => {
    // AvantStay Employee always goes last
    if (a.tag === AVANTSTAY_EMPLOYEE_TAG) return 1
    if (b.tag === AVANTSTAY_EMPLOYEE_TAG) return -1

    // Sort by hierarchy (lower number = higher priority)
    const aHierarchy = a.hierarchy ?? Infinity
    const bHierarchy = b.hierarchy ?? Infinity

    return bHierarchy - aHierarchy
  })
}

const isStringArray = (tags: FullTags[] | string[]): tags is string[] => {
  return tags.every(isString)
}

export const mapToTagStructure = (tags: FullTags[] | string[]): MappedTag[] => {
  if (isStringArray(tags)) {
    return tags.map(tag => ({
      tag,
      hierarchy: undefined,
      reason: undefined,
    }))
  }

  return tags.map(({ tag, reason }) => ({
    tag: tag.name,
    hierarchy: tag.hierarchy,
    reason,
  }))
}
